import './lib/installPrompt.js'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import ErrorBoundary from './components/ErrorBoundary.jsx'
import { initSlackErrorReporter } from './utils/slackErrorReporter.js'
import { initPWA } from './registerSW.js'

initSlackErrorReporter()
initPWA()

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
)
